import { useState } from 'react';

export const useToggle = (value = false): [boolean, (nextValue?: boolean) => void] => {
  const [state, setState] = useState(value);
  const toggle = (nextValue?: boolean) => setState(prevState => nextValue || !prevState);

  return [state, toggle];
};
